module.exports = __webpack_public_path__ + "img/element-icons-tag-cc.60e3d57b.svg";